import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { LOAN_PROGRAM_FIXED_15, LOAN_PROGRAM_FIXED_30 } from '@nerdwallet/home-constants';
export var LTV_95_97_INDEX = 0;
export var LTV_90_95_INDEX = 1;
export var LTV_85_90_INDEX = 2;
export var LTV_80_85_INDEX = 3;
export var LTV_95_97_BREAKPOINT = 0.95;
export var LTV_90_95_BREAKPOINT = 0.9;
export var LTV_85_90_BREAKPOINT = 0.85;
export var CREDIT_SCORE_BREAKPOINT_POOR = 630;
export var CREDIT_SCORE_BREAKPOINT_FAIR = 690;
export var CREDIT_SCORE_BREAKPOINT_GOOD = 720;
export var CREDIT_SCORE_BAND_EXCELLENT = 'EXCELLENT';
export var CREDIT_SCORE_BAND_GOOD = 'GOOD';
export var CREDIT_SCORE_BAND_FAIR = 'FAIR';
export var CREDIT_SCORE_BAND_POOR = 'POOR';

/**
 * Lookup table for private mortgage insurance.
 * @see https://docs.google.com/spreadsheets/d/1kBBX4Efwcbuy-1YASP4Z4g7a4C6rJnIG0OYYj5Qpdiw/edit?usp=sharing
 */
export var PMI_TABLE = _defineProperty(_defineProperty({}, LOAN_PROGRAM_FIXED_30, _defineProperty(_defineProperty(_defineProperty({}, CREDIT_SCORE_BAND_FAIR, [0.0168, 0.0126, 0.0084, 0.004]), CREDIT_SCORE_BAND_GOOD, [0.0107, 0.0085, 0.0057, 0.0025]), CREDIT_SCORE_BAND_EXCELLENT, [0.0074, 0.0057, 0.0039, 0.002])), LOAN_PROGRAM_FIXED_15, _defineProperty(_defineProperty(_defineProperty({}, CREDIT_SCORE_BAND_FAIR, [0.0154, 0.0098, 0.0046, 0.0024]), CREDIT_SCORE_BAND_GOOD, [0.0087, 0.0056, 0.0025, 0.0018]), CREDIT_SCORE_BAND_EXCELLENT, [0.0055, 0.0037, 0.0018, 0.0017]));